///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Toolbar } from 'ngx-editor';
import { defaultToolbarRules, NoteItem } from './release-notes-note-item.model';

export class GtthReleaseNotesProductCompatibility implements NoteItem {
    public readonly DIALOG_TITLE_TRANSLATION_PATH = 'releaseNotes.productCompatibility.createOrEditLabel';
    public fieldList: { title: string; content: string; editorToolbar: Toolbar }[] = [];

    constructor(
        public version?: string,
        public units?: string
    ) {
        this.fieldList.push({ title: 'version', content: this.version, editorToolbar: [] });
        this.fieldList.push({
            title: 'units',
            content: this.units,
            editorToolbar: defaultToolbarRules
        });
    }

    getPlainObject(): any {
        const releaseNoteItem = {};
        this.fieldList.forEach((field) => (releaseNoteItem[field.title] = field.content));
        return releaseNoteItem;
    }
}
